import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
import(/* webpackMode: "eager" */ "/app/node_modules/react-toastify/dist/ReactToastify.css");
import(/* webpackMode: "eager" */ "/app/src/app/BannerEvent.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/support/index.tsx");
import(/* webpackMode: "eager" */ "/app/src/provider/ClientProvider.tsx");
import(/* webpackMode: "eager" */ "/app/src/provider/HistoryProvider.tsx");
import(/* webpackMode: "eager" */ "/app/src/provider/InpaintModelProvider.tsx");
import(/* webpackMode: "eager" */ "/app/src/provider/PromptProvider.tsx");
import(/* webpackMode: "eager" */ "/app/src/styles/global.css");
import(/* webpackMode: "eager" */ "/app/src/templates/Layout.tsx")